<!-- <link rel="stylesheet" [href]='sanitizer.bypassSecurityTrustResourceUrl(clientStyle)'> -->

<div>
  <h1 class="citation-title">Citation Payment</h1>
</div>